import React from 'react'
import './Footer.css'

function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">Pokefarm</h3>
          <p className="footer-description">
            Le bot Discord Pokémon pour capturer, évoluer et compléter votre Pokédex !
          </p>
        </div>
        <nav className="footer-section" aria-label="Navigation du footer">
          <h4 className="footer-heading">Liens rapides</h4>
          <ul className="footer-links">
            <li><a href="#installation" aria-label="Aller à la section Installation">Installation</a></li>
            <li><a href="#comment-jouer" aria-label="Aller à la section Comment jouer">Comment jouer</a></li>
            <li><a href="#features" aria-label="Aller à la section Fonctionnalités">Fonctionnalités</a></li>
            <li><a href="#evolution" aria-label="Aller à la section Évolutions">Évolutions</a></li>
          </ul>
        </nav>
        <nav className="footer-section" aria-label="Liens de support">
          <h4 className="footer-heading">Support</h4>
          <ul className="footer-links">
            <li><a href="https://discord.gg/SrTAFyRt8D" target="_blank" rel="noopener noreferrer" aria-label="Rejoindre le serveur Discord">Serveur Discord</a></li>
            <li><a href="https://discord.com" target="_blank" rel="noopener noreferrer" aria-label="Voir la documentation">Documentation</a></li>
          </ul>
        </nav>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 Pokefarm. Tous droits réservés.</p>
        <p className="footer-note">Pokémon est une marque déposée de Nintendo / Game Freak</p>
      </div>
    </footer>
  )
}

export default Footer
